import React, {PropTypes} from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux'
import TextField from 'material-ui/TextField'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import Checkbox from 'material-ui/Checkbox'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Dropzone from 'react-dropzone'
import { Grid, Row, Col, Button, Image } from 'react-bootstrap';
import Classnames from 'classnames'


const normalizePhone = (value) => {
  if (!value) {
    return value
  }

  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 7) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`
}

const validate = values => {
  const errors = {}
  if (!values.first_name) {
    errors.first_name = 'Required'
  }
  if (!values.last_name) {
    errors.last_name = 'Required'
  }
  if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  if (values.phone_number && isNaN(Number(values.phone_number.replace(/-/g, '')))) {
    errors.phone_number = 'Must be a number'
  }
  console.log("errors");
  console.log(errors);
  return errors
}

class ProfileForm extends React.Component {

  constructor(props) {
    super(props)
  }

  renderDropzoneInput(field, isDragActive) {
    const files = field.input.value;

    var dropzoneBoxClassName = Classnames({
      "dropzone-box": true,
      "dropzone-box-with-preview": field.input.value.preview
    })

    return (
      <div>
        <Dropzone
          name={field.name}
          onDrop={( filesToUpload, e ) => field.input.onChange(filesToUpload[0])}
          className={dropzoneBoxClassName}
          activeClassName="dropzone-box-active"
          multiple={false}
          accept="image/*"
        >
          {field.input.value.preview && <Image className="dropped-image" src={field.input.value.preview} />}
          {!field.input.value.preview && <div><p>Add Photo or Logo</p><p className="dropezone-subcopy">(Drag & Drop or Click Here)</p> </div> }
        </Dropzone>

        {field.meta.touched &&
          field.meta.error &&
          <span className="error">{field.meta.error}</span>}

        {/*{files && Array.isArray(files) && (
          <ul>
            { files.map((file, i) => <li key={i}>{file.name} <img src={file.preview} /></li>) }

          </ul>
        )}*/}
        {/*<p>{field.input.value.name}</p>*/}
      </div>
    );
  }

  renderField({ input, label, type, meta: { touched, error } }) {
    return (
      <div>
        <TextField hintText={label}
          floatingLabelText={label}
          errorText={touched && error}
          {...input}
        />
      </div>
    )
  }

  render() {

    const { handleSubmit, submitting, onChange, onChangeFile, accountantGroupForm, onAccountantGroupFormReset } = this.props;

    const circleStyle = {
      strokeDasharray: "240px, 240px",
      strokeDashoffset: "480px"
    };
    const pathStyle = {
      strokeDasharray:"50px, 50px",
      strokeDashoffset: "0px"
    }
    const checkmark = (<span className="icon icon--order-success inlinesvg svg">
      <svg width="26px" height="26px">
        <g fill="none" stroke="#FFFFFF" stroke-width="2">
          <circle cx="13" cy="13" r="12" style={circleStyle}></circle>
          {/*<path d="M19.417,37.778l9.93,9.909l20.444-22.393" style={pathStyle}></path>*/}
          <path d="M5.817,13.778l4.93,4.909l9.444-11.393" style={pathStyle}></path>
        </g>
      </svg>
    </span>)

    var buttonContent;
    if (accountantGroupForm.success) {
      buttonContent = checkmark
      setTimeout(function(){ onAccountantGroupFormReset() }, 3000);
    } else {
      buttonContent = submitting ? "Saving..." : "Save"
    }

    return (<div>

      <form className="accountant-profile-form" onSubmit={handleSubmit} >
        <div>
          <Field onChange={onChange} name="first_name" component={this.renderField} type="text" label="First Name"/>

        </div>
        <div>
          <Field onChange={onChange} name="last_name" component={this.renderField} type="text" label="Last Name"/>
        </div>
        <div>
          <Field onChange={onChange} name="email" component={this.renderField} type="email" label="Email"/>
        </div>
        <div>
          <Field onChange={onChange} name="company_name" component={this.renderField} type="text" label="Company Name"/>
        </div>
        <div>
          <Field onChange={onChange} name="description" component={this.renderField} type="text" label="Company Description"/>
        </div>
        <div>
          <Field onChange={onChange} normalize={normalizePhone} name="phone_number" component={this.renderField} type="text" label="Phone Number"/>
        </div>
        <div>
          <Field onChange={onChangeFile} name="photo_attributes[image]" component={this.renderDropzoneInput} />
        </div>
        <div>
          <button className="btn btn-main-green" type="submit" disabled={submitting}>{buttonContent}</button>
        </div>
      </form>


    </div>);
  }
}

ProfileForm = reduxForm({
  form: 'AccountantProfileForm',
  validate: validate

})(ProfileForm);

ProfileForm = connect(
  state => ({
    initialValues: state.models.user.group_as_accountant // pull initial values from account reducer
  })
)(ProfileForm)

ProfileForm.propTypes = {
};

export default ProfileForm;



// WEBPACK FOOTER //
// ./src/accountants/ProfileForm.js